import { render, staticRenderFns } from "./Macao.vue?vue&type=template&id=75dabaef"
import script from "./Macao.vue?vue&type=script&lang=js"
export * from "./Macao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports